/* tslint:disable */
/* eslint-disable */
export enum EArcHospiActionCode {
  Admission = 'ADMISSION',
  AutoChangeLight = 'AUTO_CHANGE_LIGHT',
  ChangeLight = 'CHANGE_LIGHT',
  CreatePrehospi = 'CREATE_PREHOSPI',
  DeleteHospi = 'DELETE_HOSPI',
  DeletePrehospi = 'DELETE_PREHOSPI',
  DeskRule = 'DESK_RULE',
  OverwritingProcess = 'OVERWRITING_PROCESS',
  TestAdmission = 'TEST_ADMISSION',
  UpdateHospi = 'UPDATE_HOSPI',
  UpdatePrehospi = 'UPDATE_PREHOSPI',
  RestoreHospi = 'RESTORE_HOSPI'
}
